var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('i', {
    staticClass: " fa fa-filter filter",
    class: _vm.visible ? null : 'collapsed',
    attrs: {
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4",
      "title": "Search Filter"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse-4"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-card', [_c('form', {
    attrs: {
      "data-vv-scope": "podreupload"
    }
  }, [_c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Client Name")]), _vm._v(" "), _c('b-input-group', [_c('Multiselect', {
    attrs: {
      "options": _vm.companyNamelist,
      "name": "CompanyList",
      "placeholder": "Select Company Name",
      "label": "label",
      "track-by": "id",
      "multiple": true,
      "scroll": true
    },
    model: {
      value: (_vm.companyNameSearch),
      callback: function($$v) {
        _vm.companyNameSearch = $$v
      },
      expression: "companyNameSearch"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("AWB")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-tag' style='font-size: 12px'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AWB),
      expression: "AWB"
    }],
    staticClass: "txtarea",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "awb",
      "id": "awb",
      "placeholder": "Enter upto 10 AWB No"
    },
    domProps: {
      "value": (_vm.AWB)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AWB = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Delivery date range From ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deliveryfromdate),
      expression: "deliveryfromdate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: _vm.deliverytodate ? true : false
        }
      }),
      expression: "{ rules: { required: deliverytodate?true:false} }"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "name": "radFromDate",
      "min": _vm.minFromDate,
      "max": _vm.maxFromDate
    },
    domProps: {
      "value": (_vm.deliveryfromdate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deliveryfromdate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('podreupload.radFromDate')),
      expression: "errors.has('podreupload.radFromDate')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Delivery Date Range From is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Delivery date range To")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deliverytodate),
      expression: "deliverytodate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: _vm.deliveryfromdate ? true : false
        }
      }),
      expression: "{ rules: { required: deliveryfromdate?true:false} }"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "name": "radToDate",
      "min": _vm.minToDate,
      "max": _vm.maxToDate
    },
    domProps: {
      "value": (_vm.deliverytodate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deliverytodate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('podreupload.radToDate')),
      expression: "errors.has('podreupload.radToDate')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Delivery Date Range To is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Destination")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-crosshairs' style='font-size: 12px'></i>"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.HubList,
      "name": "destination",
      "placeholder": "Select Destination",
      "id": "destination",
      "label": "text",
      "select-label": '',
      "track-by": "value",
      "multiple": true,
      "scroll": true,
      "open-direction": "bottom"
    },
    model: {
      value: (_vm.destinationSearch),
      callback: function($$v) {
        _vm.destinationSearch = $$v
      },
      expression: "destinationSearch"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Ageing")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-crosshairs' style='font-size: 12px'></i>"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.ageOptions,
      "name": "age",
      "placeholder": "Select age  of shipment",
      "id": "age",
      "label": "text",
      "select-label": '',
      "track-by": "value",
      "multiple": false,
      "scroll": true,
      "open-direction": "bottom"
    },
    model: {
      value: (_vm.ageValue),
      callback: function($$v) {
        _vm.ageValue = $$v
      },
      expression: "ageValue"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("BA/SR Name")]), _vm._v(" "), _c('b-input-group', [_c('Multiselect', {
    attrs: {
      "options": _vm.srUserList,
      "name": "srUserList",
      "placeholder": "Select Username",
      "label": "label",
      "track-by": "id",
      "multiple": true,
      "scroll": true
    },
    on: {
      "select": _vm.selectSRUser
    },
    model: {
      value: (_vm.srUserId),
      callback: function($$v) {
        _vm.srUserId = $$v
      },
      expression: "srUserId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticStyle: {
      "margin-top": "20px"
    }
  }), _vm._v(" "), _c('b-input-group', [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "title": "Search"
    },
    on: {
      "click": function($event) {
        _vm.onSubmitSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n\t\t\t\t\t\t"), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset",
      "title": "Reset"
    },
    on: {
      "click": function($event) {
        _vm.resetFilters()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])])], 1)])])])])], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-y": "auto"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "4px"
    }
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right",
      "padding-right": "2px"
    },
    attrs: {
      "type": "button",
      "title": "Download (XLSX)"
    },
    on: {
      "click": function($event) {
        _vm.getListForPodReupload('download')
      }
    }
  }, [_vm._v("\n          Download (XLSX)\n        ")])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "width": "100%",
      "padding-top": "1px",
      "padding-bottom": "1px"
    },
    attrs: {
      "id": "otherinfo"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.podDetail.length === 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.podDetail), function(data, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "height": "40px"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm.offset + index + 1) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awb))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.destinationhubname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.deliverydatetime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.userid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.age))]), _vm._v(" "), _c('td', [(data.podSaved === false) ? _c('podUploadComponent', {
      attrs: {
        "rowData": data
      },
      on: {
        "customEvent": _vm.handleCustomEvent,
        "updateList": _vm.updateList
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', [(data.podSaved === true) ? _c('span', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v("Uploaded")]) : _vm._e(), _vm._v(" "), (data.podSaved === false) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Pending")]) : _vm._e()])])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  })], 1)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sr.No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("WayBill No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination Branch")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Delivery Date and Time")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("BA Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("BA ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Ageing")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00ba10a6","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/TripManagement/CreateTripManagement/closeTrip/podReupload/podReupload.component.html
// module id = 2002
// module chunks = 3